import { render, staticRenderFns } from "./AnniversaryLogo.vue?vue&type=template&id=c1f78dc0"
import script from "./AnniversaryLogo.vue?vue&type=script&lang=js"
export * from "./AnniversaryLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports